import React from "react";

const Publications = () => {
    return (
        <div class="container mx-auto px-0 pt-5 sm:px-5 sm:pt-7 md:px-10 lg:px-20 lg:pt-10 font-['Times']">
            <br/>
            <h1 class="text-xl sm:text-2xl lg:text-3xl font-bold">Publications</h1>
            <div class="text-base sm:text-lg lg:text-xl md:text-2xl"> 
                <div>
                    <h2 class="font-bold pt-4 text-red-700">The Impacts of Unanswerable Questions on the Robustness of Machine Reading Comprehension Models</h2>
                    <p> <b>Son Quoc Tran</b>, Phong Nguyen-Thuan Do, Uyen Le, Matt Kretchmar<br/>
                    <b>EACL 2023</b></p>
                    <a href="https://aclanthology.org/2023.eacl-main.113/" class="text-red-700" target="_blank" rel="noopener noreferrer"><u>Paper</u> </a>
                    ●
                    <a href="https://github.com/sonqt/unanswerable-robustness" class="text-red-700" target="_blank" rel="noopener noreferrer"> <u>Code</u> </a>
                    ●
                    <a href="https://www.youtube.com/watch?v=YDR8WhPjrj0" class="text-red-700" target="_blank" rel="noopener noreferrer"> <u>Talk</u></a>
                </div>

                <div>
                    <h2 class="font-bold pt-4 text-red-700">Revealing Weaknesses of Vietnamese Language Models Through Unanswerable Questions in Machine Reading Comprehension</h2>
                    <p> <b>Son Quoc Tran</b>, Phong Nguyen-Thuan Do, Kiet Van Nguyen, Ngan Luu-Thuy Nguyen<br/>
                    <b>SRW @ EACL 2023</b></p>
                    <a href="https://aclanthology.org/2023.eacl-srw.1/" class="text-red-700" target="_blank" rel="noopener noreferrer"><u>Paper</u> </a>
                </div>

                <div>
                    <h2 class="font-bold pt-4 text-red-700">VLUE: A New Benchmark and Multi-task Knowledge Transfer Learning for Vietnamese Natural Language Understanding</h2>
                    <p>Phong Nguyen-Thuan Do, <b>Son Quoc Tran</b>, Phu Gia Hoang, Kiet Van Nguyen, Ngan Luu-Thuy Nguyen<br/>
                    <b>Findings of NAACL 2024</b></p>
                    <a href="https://arxiv.org/abs/2403.15882" class="text-red-700" target="_blank" rel="noopener noreferrer"><u>Paper</u> </a>
                </div>

                <div>
                    <h2 class="font-bold pt-4 text-red-700">VLSP 2021 - ViMRC Challenge: Vietnamese Machine Reading Comprehension</h2>
                    <p> Kiet Van Nguyen, <b>Son Quoc Tran</b>, Luan Thanh Nguyen, Tin Van Huynh, Son Thanh Luu, Ngan Luu-Thuy Nguyen<br/>
                    <b>VLSP 2021</b></p>
                    <a href="https://arxiv.org/abs/2203.11400" class="text-red-700" target="_blank" rel="noopener noreferrer"><u>Paper</u> </a>
                </div>

            </div>
            
            <br/>
            <h1 class="text-xl sm:text-2xl lg:text-3xl font-bold">Under Review</h1>
            <div class="text-base sm:text-lg lg:text-xl md:text-2xl">
                <div>
                    <h2 class="font-bold pt-4 text-red-700"><i>AGent</i>: A Novel Pipeline for Automatically Generating Unanswerable Questions</h2>
                    <p> <b>Son Quoc Tran</b>, Gia-Huy Hoang Do, Phong Nguyen-Thuan Do, Matt Kretchmar, Xinya Du<br/>
                    <i>Under review</i></p>
                    <a href="https://arxiv.org/abs/2309.05103" class="text-red-700" target="_blank" rel="noopener noreferrer"><u>Paper</u> </a>
                    ●
                    <a href="https://github.com/sonqt/agent-unanswerable" class="text-red-700" target="_blank" rel="noopener noreferrer"> <u>Code</u> </a>
                </div>

                <div>
                    <h2 class="font-bold pt-4 text-red-700">Single-Sentence Reader: A Novel Approach for Addressing Position Bias</h2>
                    <p> <b>Son Quoc Tran</b>, Matt Kretchmar<br/>
                    <i>Under review</i></p>
                    <a href="https://arxiv.org/abs/2308.04566" class="text-red-700" target="_blank" rel="noopener noreferrer"><u>Paper</u> </a>
                    ●
                    <a href="https://github.com/sonqt/single-sentence-reader" class="text-red-700" target="_blank" rel="noopener noreferrer"> <u>Code</u> </a>
                </div>

                
            </div>

        </div>
    )
};
export default Publications;
